import { BASE_URL } from './config';
export const buildCatalogURL = ({
    typeCatalogue,
    typeBook,
    latestBook,
    popularBook,
    title,
    typeSearchBook,
    level,
    classFilter,
    lessonFilter,
    tag
  }) => {
    let classPattern = classFilter?.join('&') || '';
    let lessonPattern = lessonFilter?.join('&') || '';
  
    let ENDPOINTS_URL = `${BASE_URL}/api/catalogue/${typeCatalogue}?limit=2000&${typeBook}&order_by=updated_at`;
  
    if (latestBook) ENDPOINTS_URL += `&${latestBook}`;
    if (level) ENDPOINTS_URL += `&${level}`;
    if (classPattern) ENDPOINTS_URL += `&${classPattern}`;
    if (lessonPattern) ENDPOINTS_URL += `&${lessonPattern}`;
    if (tag) ENDPOINTS_URL += `&tag=${tag}`;
  
    if (popularBook) {
      ENDPOINTS_URL = `${BASE_URL}/api/statistic/${popularBook}?qty=20`;
    }
  
    if (title && !popularBook) {
      switch (typeSearchBook) {
        case 'Kurikulum Merdeka':
          ENDPOINTS_URL = `${BASE_URL}/api/catalogue/getPenggerakTextBooks?title=${title}&limit=20&offset=0`;
          break;
        case 'Teks K13':
          ENDPOINTS_URL = `${BASE_URL}/api/catalogue/getTextBooks?title=${title}&limit=20&offset=0`;
          break;
        case 'Nonteks':
          ENDPOINTS_URL = `${BASE_URL}/api/catalogue/getNonTextBooks?title=${title}&limit=20&offset=0&sort=desc`;
          break;
      }
    }
  
    return ENDPOINTS_URL;
  };  